module.exports = __webpack_public_path__ + "static/img/AA5504305.e45bf9ff.jpg";